import React from 'react';
import { SvgIcon } from '@mui/material';

function ReorderIcon(props) {
  return (
    <SvgIcon {...props}>
      <g clipPath="url(#clip0_22511_972)">
        <path
          d="M2 10H14V8.66668H2V10ZM2 12.6667H14V11.3333H2V12.6667ZM2 7.33334H14V6.00001H2V7.33334ZM2 3.33334V4.66668H14V3.33334H2Z"
          fill="#C7CAE6"
        />
      </g>
      <defs>
        <clipPath id="clip0_22511_972">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default ReorderIcon;
